import React, { useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { Col, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getIsAuth } from 'Redux/selectors/auth'
import { getOfferedCampaigns, setToken } from 'Redux/actions/influencerActions'
import { TracksContainer, Container, TracksTitle } from './styles'
import { TracksTable } from './components/TracksTable'
import { DetailsModal } from './components/DetailsModal'

const Tracks = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const isAuth = useSelector(getIsAuth)
  const token = useMemo(() => queryString.parse(location.search)?.authToken, [
    location.search,
  ])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.has('error')) {
      queryParams.delete('error')
      history.replace({
        search: queryParams.toString(),
      })
    }
  }, [])

  useEffect(() => {
    if (token) {
      dispatch(setToken(token))
      const queryParams = new URLSearchParams(location.search)
      if (queryParams.has('authToken')) {
        queryParams.delete('authToken')
        history.replace({
          search: queryParams.toString(),
        })
      }
    }
  }, [token])

  return (
    <TracksContainer>
      <Container>
        <Col lg={12} md={12} xl={12}>
          <Row>
            <Col md={12}>
              <TracksTitle>{t('influencer.tracksPageTitle')}</TracksTitle>
            </Col>
          </Row>
        </Col>

        <TracksTable t={t} />

        <DetailsModal />
      </Container>
    </TracksContainer>
  )
}

export default Tracks
